import {combineReducers} from "redux";
import {feedback} from "../modules/feedback/FeedbackReducer";
import {survey} from "../modules/survey/SurveyReducer";
import { routerReducer } from 'react-router-redux';
import { application } from "./AppReducer";

const index = combineReducers({feedback, survey, routerReducer, application});
export default index;



// WEBPACK FOOTER //
// ./src/reducer/index.js